import { render, staticRenderFns } from "./assignMoney.vue?vue&type=template&id=cab3e0d2&scoped=true&"
import script from "./assignMoney.vue?vue&type=script&lang=js&"
export * from "./assignMoney.vue?vue&type=script&lang=js&"
import style0 from "./assignMoney.vue?vue&type=style&index=0&id=cab3e0d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab3e0d2",
  null
  
)

export default component.exports